module.exports = __webpack_public_path__ + "media/alaska/mounts-6013355e.jpg";